import { Add, Button, Clickable, Col, Icon, Row, Text } from 'components';
import { isToday, isYesterday } from 'date-fns';
import { formatLocale, getRound, theme } from 'lib';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { ProgressBadge, Score } from './';

const UserAvatar = styled.div`
  width: 55px;
  height: 55px;
  border-radius: 55px;
  margin-bottom: 13px;
  background-image: url(${(props) => props.src});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`;

const TopSection = ({ data, closeModal }) => {
  const date = new Date(data.date);
  const { location, score, gameStatus, status, progress, home, dataInfo, away, sport } = data;

  const [shoutoutVisible, setShoutoutVisible] = useState(),
    [modalVisible, setModalVisible] = useState(false),
    dispatch = useDispatch(),
    { t } = useTranslation(),
    { isMobile } = useSelector((state) => state.appState),
    round = getRound(data.round, dataInfo.leagueId);

  function handleGetApp() {
    dispatch({
      type: 'UPDATE_APP_STATE',
      payload: {
        showGetApp: true
      }
    });

    closeModal();
  }

  return (
    <Col
      noFlex
      bg="#000"
      pad={isMobile ? '0 16px' : '0 24px'}
      wid={isMobile ? 'calc(100% - 32px)' : 'calc(100% - 48px)'}
    >
      <Row between center pad="26px 0 34px">
        <Text h2 col="#fff" maxWid="90%">
          {home.name} - {away.name}
        </Text>

        <Row noFlex>
          <Clickable marg="0 0 0 21px" onClick={closeModal}>
            <Icon type="close" col="#fff" dimensions={14} />
          </Clickable>
        </Row>
      </Row>

      <Col wid="358px" center>
        <Col center>
          {round && (
            <Text col="#fff" b2 center>
              {!isNaN(round) ? t('games.matchday', { round }) : t(`games.${round}`)}
            </Text>
          )}

          <Text col="#fff" b2 center>
            {location}
          </Text>
        </Col>

        <Row between marg="24px 0 0">
          <Col noFlex centerAll wid="130px">
            <UserAvatar src={home.avatar} />

            <Text wid="100%" center col="#fff" bold>
              {home.name}
            </Text>
          </Col>

          <Col centerAll>
            {['live', 'finished'].includes(status) ? (
              <Score score={score} sport={sport} />
            ) : (
              <Col center marg="0 0 13px" ht="55px">
                <Text col="#fff" med marg="0 0 2px" center>
                  {isToday(date)
                    ? t('common.today')
                    : isYesterday(date)
                      ? t('common.yesterday')
                      : formatLocale(date, 'MMM dd, iii')}
                </Text>

                <Text col="#fff" med>
                  {formatLocale(date, 'h:mm aa')}
                </Text>
              </Col>
            )}

            <Row noFlex ht="22px">
              <ProgressBadge
                status={status}
                gameStatus={gameStatus}
                progress={progress}
                sport={sport}
              />
            </Row>
          </Col>

          <Col noFlex centerAll wid="130px">
            <UserAvatar src={away.avatar} />

            <Text wid="130px" center col="#fff" bold>
              {away.name}
            </Text>
          </Col>
        </Row>

        <Col center marg="32px 0">
          <Row noFlex gap="16px">
            <Button
              bg={theme.SECONDARY}
              text={t('common.shoutOut')}
              icon="shoutoutOutline"
              iconSize={22}
              pad="0 22px"
              onClick={() => setModalVisible(true)}
            />

            {/* <Button
              bordered
              reverse
              text={t('common.checkIn')}
              icon='checkIn'
              iconSize={22}
              pad='0 22px'
            /> */}
          </Row>
        </Col>
      </Col>

      <Add
        visible={modalVisible}
        setVisible={setModalVisible}
        preSelectData={{
          eventObject: data
        }}
        preSelect={2}
        preSelectPage="shoutoutGame"
      />
    </Col>
  );
};

// <UserSelectModal
//   visible={shoutoutVisible}
//   closeModal={handleShoutoutVisible}
//   users={users}
//   eventId={_id}
// />

export default TopSection;
